import * as yup from 'yup';
import { Row, RenderConfig, AsyncSelect, TextInput } from 'commons-ui';
import { FORM_FIELD_KEYS } from './constants';

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.MANAGER_NAME),
	new Row(FORM_FIELD_KEYS.DEPARTMENT),
	new Row(FORM_FIELD_KEYS.DESIGNATION),
	new Row(FORM_FIELD_KEYS.ROLE_NAME_TEMP),
	new Row(FORM_FIELD_KEYS.EMAIL)
];

export const validationSchema = yup
	.object()
	.shape({
		managerName: yup.string().optional(),
		department: yup.string().optional(),
		designation: yup.string().optional(),
		roleNameTemp: yup.string().optional(),
		email: yup.string().email('Please enter a valid email').optional()
	})
	.test('at-least-one', 'Please enter at least one filter field', (value) => {
		if (!value) return false;
		const { managerName, department, designation, roleNameTemp, email } = value as Record<string, any>;
		return Boolean(managerName || department || designation || roleNameTemp || email);
	});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.MANAGER_NAME]: new RenderConfig()
		.setName('managerName')
		.setLabel('Manager Name')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true }
		}),
	[FORM_FIELD_KEYS.DEPARTMENT]: new RenderConfig()
		.setName('department')
		.setLabel('Department')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true }
		}),
	[FORM_FIELD_KEYS.DESIGNATION]: new RenderConfig()
		.setName('designation')
		.setLabel('Designation')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true }
		}),
	[FORM_FIELD_KEYS.ROLE_NAME_TEMP]: new RenderConfig()
		.setName('roleNameTemp')
		.setLabel('Role Name (Temporary)')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true }
		}),
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName('email')
		.setLabel('Email')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true }
		})
};
